// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GJui","clinicsSelect":"styles_clinicsSelect__3qQIF"};